import { computed, toValue, watch } from "vue";
import { useExponentialSlider } from "wucdbm-exponential-slider";
function useStepModel(model, steps, bounds, linearConfig, options = {
  watchBounds: false,
  fixModelOnInit: false
}) {
  const modelBeautifier = options.modelBeautifier || ((model2) => model2);
  const calculator = computed(() => {
    return useExponentialSlider(
      toValue(steps),
      toValue(bounds),
      toValue(linearConfig)
    );
  });
  const stepModel = computed({
    get() {
      const { modelToStep: modelToStep2 } = calculator.value;
      const modelValue = toValue(model);
      return {
        min: modelToStep2(modelValue.min),
        max: modelToStep2(modelValue.max)
      };
    },
    set(b) {
      const { stepToModel: stepToModel2 } = calculator.value;
      model.value = {
        min: modelBeautifier(stepToModel2(b.min), "min"),
        max: modelBeautifier(stepToModel2(b.max), "max")
      };
    }
  });
  if (options.watchBounds) {
    watch(bounds, (newBounds, oldBounds) => {
      if (JSON.stringify(newBounds) === JSON.stringify(oldBounds)) {
        return;
      }
      const { stepToModel: stepToModel2 } = calculator.value;
      model.value = {
        min: modelBeautifier(stepToModel2(stepModel.value.min), "min"),
        max: modelBeautifier(stepToModel2(stepModel.value.max), "max")
      };
    });
  }
  if (options.fixModelOnInit) {
    const { stepToModel: stepToModel2 } = calculator.value;
    const modelForValueModel = {
      min: modelBeautifier(stepToModel2(stepModel.value.min), "min"),
      max: modelBeautifier(stepToModel2(stepModel.value.max), "max")
    };
    if (JSON.stringify(modelForValueModel) !== JSON.stringify(model.value)) {
      model.value = modelForValueModel;
    }
  }
  return {
    model: stepModel,
    modelToStep: (model2) => {
      return calculator.value.modelToStep(model2);
    },
    stepToModel: (step) => {
      return calculator.value.stepToModel(step);
    },
    config: computed(() => calculator.value.config)
  };
}
export {
  useStepModel
};
